module.exports = __webpack_public_path__ + "static/media/team-member-5.63a2f8c2.png";